import React from 'react';

import MinimalLayout from 'signer-app/parts/minimal-layout';
import { siteCodeSign } from 'js/sign-components/common/brand';
import ProgressiveCheckoutSignInForm from 'hellospa/page/authentication/progressive-checkout-sign-in-form';
import SignInForm from 'hellospa/page/authentication/sign-in-form';
import { CountryCodeProvider } from 'signer-app/authentication/use-country-code';
import { setCsrfToken } from 'js/sign-components/common/hs-fetch';
import { FeatureFlagProvider } from 'js/sign-components/common/feature-flag';

type LoginFormProps = {
  csrfToken: string;
  planId?: string;
  selectedPlanId?: string;
  selected_plan_id?: string;
};

function LoginForm({
  csrfToken,
  planId,
  selectedPlanId: selectedPlanIdProp,
  selected_plan_id: selectedPlanIdSnakeCaseProp,
}: LoginFormProps) {
  const selectedPlanIdFromQuery =
    typeof window === 'undefined'
      ? undefined
      : new URLSearchParams(window.location.search).get('selected_plan_id') ??
        undefined;
  const selectedPlanId =
    selectedPlanIdProp ??
    selectedPlanIdSnakeCaseProp ??
    planId ??
    selectedPlanIdFromQuery;
  const hasSelectedPlan = Boolean(selectedPlanId);

  setCsrfToken(csrfToken);

  return (
    // @ts-ignore window.config comes from backend
    <FeatureFlagProvider featureFlags={window?.config?.featureFlags || {}}>
      <MinimalLayout siteCode={siteCodeSign} locale="en-US" contentCentered>
        <CountryCodeProvider>
          <div style={{ width: '100%', maxWidth: '420px', margin: '0 auto' }}>
            {hasSelectedPlan ? (
              <ProgressiveCheckoutSignInForm
                hideCreateAccountLink
                redirectUrl={window.location.href}
              />
            ) : (
              <SignInForm
                hideCreateAccountLink
                redirectUrl={window.location.href}
              />
            )}
          </div>
        </CountryCodeProvider>
      </MinimalLayout>
    </FeatureFlagProvider>
  );
}

export default LoginForm;
